import React from "react";
import { Link } from "react-router-dom";
import blogs from "../data/blogs";
import BlogCarousel from "../components/BlogCarousel";
import amazonIcon from "../assets/icons/amazon.png";
import flipkartIcon from "../assets/icons/flipkart.png";
import meeshoIcon from "../assets/icons/meesho.png";

export default function Home() {
  return (
    <div className="px-6 py-10 text-toast-blue bg-white font-toast">
      <section className="text-center mb-12">
        <h1 className="text-4xl font-extrabold mb-4">Welcome to PDFCropEase</h1>
        <p className="text-lg text-gray-700 mb-6">Crop, Merge & Generate Shipping Labels with Ease.</p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-bold mb-6 text-center">Our Tools</h2>
        <p className="text-center text-gray-600 mb-6">
          Explore our powerful tools designed to make your shipping label tasks effortless. 
          Whether it's cropping, merging, or creating, we've got you covered!
        </p>
        <div className="grid sm:grid-cols-3 lg:grid-cols-3 gap-6">
          <Link to="/meesho" className="block border p-4 rounded shadow hover:bg-indigo-50">
          <img src={meeshoIcon} alt="Meesho" className="w-6 h-6 inline-block mr-2" />
          <span className="font-medium">Crop Meesho Shipping Labels</span>

            <p className="text-sm text-gray-500 mt-2">Perfectly crop Meesho labels in seconds!</p>
          </Link>
          <Link to="/flipkart" className="block border p-4 rounded shadow hover:bg-indigo-50">
          <img src={flipkartIcon} alt="Flipart" className="w-6 h-6 inline-block mr-2" />
<          span className="font-medium">Crop Flipkart Shipping Labels</span>

          
            <p className="text-sm text-gray-500 mt-2">Simply crop your Flipkart label Easily!</p>
          </Link>
          <Link to="/amazon" className="block border p-4 rounded shadow hover:bg-indigo-50">
          <img src={amazonIcon} alt="Amazon" className="w-6 h-6 inline-block mr-2" />
          <          span className="font-medium">Crop Amazon Shipping Labels</span>
             
            <p className="text-sm text-gray-500 mt-2">Effortlessly crop Amazon shipping labels!</p>
          </Link>
          <Link to="/pdf-merge" className="block border p-4 rounded shadow hover:bg-indigo-50">
            📎 Merge Shipping Label PDFs
            <p className="text-sm text-gray-500 mt-2">Combine PDFs with just a click!</p>
          </Link>
          <Link to="/create-label" className="block border p-4 rounded shadow hover:bg-indigo-50">
            📝 Create Custom Shipping Label
            <p className="text-sm text-gray-500 mt-2">Design labels tailored to your needs!</p>
          </Link>
        </div>
        <div className="mt-8">
          <BlogCarousel />
        </div>
      </section>

      <section className="mb-12">
        <h2 className="text-xl font-bold text-center mb-4">How It Works</h2>
        <div className="grid sm:grid-cols-3 text-center gap- 1">
          <div>
            <div className="text-3xl mb-2">📤</div>
            <p>Upload your PDF</p>
            <p className="text-sm text-gray-500 mt-2">Start by uploading your file effortlessly.</p>
          </div>
          <div>
            <div className="text-3xl mb-2">✂️</div>
            <p>Smart Crop or Merge</p>
            <p className="text-sm text-gray-500 mt-2">Let our tools handle the heavy lifting!</p>
          </div>
          <div>
            <div className="text-3xl mb-2">📥</div>
            <p>Download clean file</p>
            <p className="text-sm text-gray-500 mt-2">Get your polished file instantly.</p>
          </div>
        </div>
      </section>

      <section className="text-center text-gray-600">
        <h2 className="text-lg font-semibold mb-2">Why Choose CropEase?</h2>
        <ul className="space-y-2">
          <li>✅ Instant Cropping</li>
          <li>✅ Smart Detection</li>
          <li>✅ Free & No Signup</li>
          <li>✅ Works on Mobile & Desktop</li>
        </ul>
      </section>

      <footer className="text-sm text-gray-500 mt-10 pt-4 border-t text-center">
      © 2025 by Drenx Technologies. All rights reserved. <br />
        📘 <a href="#" className="hover:underline">Facebook</a> &nbsp;
        📸 <a href="#" className="hover:underline">Instagram</a> &nbsp;
        ▶️ <a href="#" className="hover:underline">YouTube</a>
      </footer>
    </div>
  );
}
